
import Vue from 'vue'
import RLoader from '@/components/forms/RLoader.vue'
import RIcon from '@/components/icons/index.vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'GoogleSignInButton',
  components: { RLoader, RIcon, RButton },
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    spinning: {
      type: Boolean,
      required: false,
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isDisabled() {
      return this.spinning || this.disabled
    },
  },
})
